// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__22HKS","title":"Header_title__3L4gn","left":"Header_left__wlVJq","clinicName":"Header_clinicName__1rnOB"};